import { Icon, IconProps } from './Icon';

export type DownArrowProps = IconProps;

const DownArrow = (props: DownArrowProps) => (
  <Icon fill="none" viewBox="0 0 44 12.154" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={4}
      d="m2 2 19.63 8L42 2"
    />
  </Icon>
);

export { DownArrow };
